import { el, setChildren, setAttr } from 'redom';

import Tooltip from 'generics/components/tooltip/native';

class MoreActionsMenuButton {

  constructor(configuration) {

    this.icon = configuration.icon;
    this.label = configuration.label;
    this.onClick = configuration.onClick;
    this.skipLabel = configuration.skipLabel || false;
    this.labelElement = el('label', this.label);
    this.tooltip = null;

    const children = this.determineChildren();

    if (configuration.skipLabel === true) {
      configuration.class += (configuration.class || '') + ' skip-label';
    }

    this.el = el('button.delete-page-button', {
      id: configuration.id || `menu-${performance.now()}`,
      class: 'more-actions-menu-button ' + (configuration.class || ''),
      type: 'button',
      onclick: this.handleClick.bind(this)
    }, children);

    if (configuration.skipLabel === true) {
      this.tooltip = new Tooltip({
        content: this.label,
        target: this.el,
        placement: 'top',
        offset: 5,
        placeOnCenter: true
      });
    }

  }

  determineChildren() {

    const children = [this.icon.cloneNode(true)];

    if (this.skipLabel !== true) {
      children.push(this.labelElement);
    }

    return children;

  }

  onunmount() {

    // I see no reason for tooltip to be null when onunmount is called.
    // But, it is happening & I do not have time.
    // So, checking for null.
    if (this.tooltip === null) {
      return;
    }

    this.tooltip.destroy();
    this.tooltip = null;

  }

  async handleClick(event) {

    const children = this.determineChildren();

    children[0] = el('ht-spinner', { size: 'tiny' });

    setChildren(this.el, children[0]);
    setAttr(this.el, { disabled: true });
    this.el.classList.add('working');

    try {

      await this.onClick(event);

    } catch (exception) {

      throw exception;

    } finally {
      children[0] = this.icon.cloneNode(true);
      setChildren(this.el, children);
      setAttr(this.el, { disabled: false });
      this.el.classList.remove('working');
    }

  }

}

export default MoreActionsMenuButton;